import Head from 'next/head';
import Contact from '../src/legacy/components/pages/Contact/Contact';

export const ContactPage = (): JSX.Element => (
  <>
    <Head>
      <title>Bounce</title>
    </Head>

    <Contact />
  </>
);

export async function getStaticProps() {
  return {
    props: {} // will be passed to the page component as props
  };
}

export default ContactPage;
